// extracted by mini-css-extract-plugin
export default {"faq-section":"faq_faq-section__LtH5l","faq":"faq_faq__hOGrs","faq-h2":"faq_faq-h2__zcgD7","faq-p":"faq_faq-p__QcBBu","icon":"faq_icon__HxLbu","faq-avatars":"faq_faq-avatars__Kh3Al"};